import { useLocation, useParams } from "react-router-dom";
import useWorkbenchBasePath from "rwb/pages/project/hooks/useWorkbenchBasePath";

/**
 * True when the file browser is rendered as a workbench's own file subtree, as
 * opposed to the global/dataset file contexts or the embedded pickers that
 * render file rows outside `/files` (pipeline run creation, for instance).
 *
 * Keyed on the resolved workbench root rather than a literal `/workbenches/...`
 * match, because the same routes are also mounted inside the nextgen project
 * shell — matching the legacy prefix would report the embedded browser global.
 */
const useIsWorkbenchFileContext = () => {
  const { projectId } = useParams();
  const { pathname } = useLocation();
  const filesRoot = `${useWorkbenchBasePath()}/files`;
  return Boolean(projectId) && (pathname === filesRoot || pathname.startsWith(`${filesRoot}/`));
};

export default useIsWorkbenchFileContext;
